import React, { useEffect, useState } from "react";
import Menu from "../../components/Menu";
import { useNavigate } from "react-router-dom";
import api from '../../apiFormData'
import Swal from 'sweetalert2'

import InputImage from "../../components/InputImage";
import InputCPF from "../../components/InputCPF";
import InputPhoneMobile from "../../components/InputPhoneMobile";
import InputPhoneMobileFull from "../../components/InputPhoneMobileFull";
import InputDate from "../../components/InputDate";
import Validations from '../../Validations'
import LoadingBlock from "../../components/LoadingBlock";
import Avatar from '../../assets/img/doctor.svg'
import "./Professionals.css"
import FooterAdd from "../../components/FooterAdd";
import { Form } from "react-bootstrap";
import formatCurrency from "../../utils/formatCurrency";
import parseMaskedMoney from "../../utils/parseMaskedMoney";
function ProfessionalsAdd() {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState({
        name: false,
        cpf: false,
        email: false,
        phoneMobile: false,
        birth: false,
        councilState: false,
        isAchemed: false,
        whatsappNumber: false
    })

    const [name, setName] = useState("")
    const [nickName, setNickname] = useState("")
    const [cpf, setCpf] = useState("")

    const [birth, setBirth] = useState("")
    const [email, setEmail] = useState("")
    const [phoneMobile, setPhoneMobile] = useState("")

    const [isAchemed, setIsAchemed] = useState(false)

    const [councilName, setCouncilName] = useState("")
    const [councilState, setCouncilState] = useState("")
    const [councilNumber, setCouncilNumber] = useState("")

    const [image, setImage] = useState({
        fileReal: '',
        file: ''
    })

    const [whatsappSchedule, setWhatsappSchedule] = useState(false)
    const [whatsappNumber, setWhatsappNumber] = useState("")

    const [minutes, setMinutes] = useState(null)
    const [expense, setExpense] = useState(null)

    useEffect(() => {
        if (!whatsappSchedule) {
            setWhatsappNumber("")
        }
    }, [whatsappSchedule])

    const onSubmit = (ev) => {
        ev.preventDefault()
        var errors = {
            name: name.replaceAll(' ', '') === '' ? true : false,
            nickName: name.replaceAll(' ', '') === '' ? true : false,
            cpf: !Validations.CPFValid(cpf),
            email: !Validations.emailValid(email),
            phoneMobile: phoneMobile === "" ? true : !Validations.PhoneMobile(phoneMobile),
            birth: birth === "" ? true : Validations.DateDDMMAAAAInvalid(birth),
            councilState: councilState === "" ? true : false,
            isAchemed: (isAchemed !== true && isAchemed !== false) ? true : false,
            //whatsappNumber: whatsappNumber === "" ? true : !Validations.PhoneMobileFull(whatsappNumber),
        }
        setError(errors)
        var validations = true

        for (const key in errors) {
            if (errors.hasOwnProperty(key) && errors[key] === true) {
                validations = false;
            }
        }

        if (whatsappSchedule && !Validations.PhoneMobileFull(whatsappNumber)) {
            return Swal.fire({
                title: "Insira um número válido para agendamento via Whatsapp (ou desmarque essa opção)",
                icon: 'error',
                confirmButtonColor: '#3c8dbc',
            })
        }

        if (validations) {
            var form = new FormData()
            image.fileReal !== '' ? form.set("image", image.fileReal) : console.log('')
            //form.set("id", id)
            form.set("cpf", cpf.replaceAll(".", "").replaceAll("-", ""));
            form.set("name", name);
            form.set("nick_name", nickName);
            form.set("birth", birth.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3$2$1'));
            form.set("council_name", councilName);
            form.set("council_state", councilState);
            form.set("council_number", councilNumber);
            form.set("email", email.replaceAll(" ", ""));
            form.set("mobile", phoneMobile.replaceAll(' ', '').replaceAll('(', '').replaceAll(')', '').replaceAll('-', ''));
            form.set("is_achemed", isAchemed);
            form.set("flag_whatsapp_scheduling", whatsappSchedule);
            form.set("whatsapp_number_scheduling", whatsappSchedule ? whatsappNumber.replace(/[^\d+]/g, "") : '');

            form.set("price_video_minutes", parseMaskedMoney(minutes))
            form.set("price_fixed_expense", parseMaskedMoney(expense))

            setLoading(true)
            api.post("/api/professionals", form).then((response) => {

                navigate("/professionals/")

                Swal.fire({
                    title: "Profissional cadastrado com sucesso",
                    icon: 'success',
                    confirmButtonColor: '#3c8dbc',
                })
            }).catch((error) => {
                console.error(error)
                Swal.fire({
                    title: "Profissional não cadastrado",
                    text: error.message,
                    icon: 'error',
                    confirmButtonColor: '#3c8dbc',
                })
            }).finally(() => {
                setLoading(false)
            })
        }

    }
    const screenTela =
        <>
            {loading && <LoadingBlock />}

            <form onSubmit={onSubmit}>
                <div className='screenContainer edit-mode'>
                    <h1>Profissional</h1>

                    <div className="row">
                        <h4>Dados Básicos</h4>

                        <div className="d-flex justify-content-center col-12">
                            <InputImage imageAvatar={Avatar} image={image} setImage={setImage} />
                        </div>

                        <div className="col-12 row my-3">
                            <div className="col-12 col-md-4">
                                <label className="form-label-input">Nome*</label>
                                <input className="form-control" value={name} type="text" name="name" placeholder="Nome" onChange={value => setName(value.target.value.toUpperCase())} />
                                {error.name && <span className="error" >Campo Inválido</span>}
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="form-label-input">Nome Abreviado*</label>
                                <input className="form-control" value={nickName} type="text" name="nickname" placeholder="Nome Abreviado" onChange={value => setNickname(value.target.value.toUpperCase())} />
                                {error.nickName && <span className="error" >Campo Inválido</span>}
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="form-label-input">Email*</label>
                                <input className="form-control" value={email} onChange={value => setEmail(value.target.value)} type="text" name="email" placeholder="Email" />
                                {error.email && <span className="error" >Campo Inválido</span>}
                            </div>
                        </div>

                        <div className="col-12 row">
                            <div className="col-12 col-md-4">
                                <label className="form-label-input">CPF*</label>
                                <InputCPF value={cpf} onChange={setCpf} />
                                {error.cpf && <span className="error" >Campo Inválido</span>}
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="form-label-input">Data de Nascimento</label>
                                <InputDate value={birth} onChange={setBirth} />
                                {error.birth && <span className="error" >Campo Inválido</span>}
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="form-label-input">Celular</label>
                                <InputPhoneMobile value={phoneMobile} onChange={setPhoneMobile} />
                                {error.phoneMobile && <span className="error" >Campo Inválido</span>}
                            </div>
                        </div>

                        <div className="col-12 row mt-3">
                            <div className="col-12 col-md-4 align-self-center">
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="isAchemed" checked={isAchemed} onChange={() => setIsAchemed(!isAchemed)} />
                                    <label className="form-check-label" htmlFor="isAchemed">Pronto-atendimento 24h</label>
                                </div>
                                {error.isAchemed && <span className="error">Campo Inválido</span>}
                            </div>

                            <div className="col-12 col-md-4 align-self-center">
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="whatsappSchedule" checked={whatsappSchedule} onChange={() => setWhatsappSchedule(!whatsappSchedule)} />
                                    <label className="form-check-label" htmlFor="whatsappSchedule">Agendamento por Whatsapp</label>
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="form-label-input">Telefone de agendamento</label>
                                <InputPhoneMobileFull value={whatsappNumber} onChange={setWhatsappNumber} disabled={!whatsappSchedule} />
                                {error.whatsappNumber && <span className="error" >Campo Inválido</span>}
                            </div>
                        </div>

                        <div className="col-12 row mt-3">
                            <div className="col-12 col-md-4">
                                <label className="form-label-input">Minutagem (R$)</label>
                                <Form.Control
                                    name="minutes"
                                    type="text"
                                    placeholder="R$ 0,00"
                                    value={minutes}
                                    onChange={(e) => setMinutes(formatCurrency(e.target.value))}
                                />
                                {/* <input type="number" value={minutes} onChange={e => setMinutes(e.target.value)} className="form-control" name="minutes" placeholder="Minutagem" /> */}
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="form-label-input">Despesa APP (R$)</label>
                                <Form.Control
                                    name="expense"
                                    type="text"
                                    placeholder="R$ 0,00"
                                    value={expense}
                                    onChange={(e) => setExpense(formatCurrency(e.target.value))}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row row-mod-hei mt-4">
                        <h4>Dados do CRM</h4>

                        <div className="col-12 col-sm-4" >
                            <label className="form-label-input">Nome</label>
                            <input className="form-control" value={councilName} onChange={value => {
                                setCouncilName(value.target.value.toUpperCase())
                            }} type="text" name="council_name" placeholder="CRM Sigla" />
                        </div>

                        <div className="col-12 col-sm-4">
                            <label className="form-label-input">Número</label>
                            <input className="form-control" value={councilNumber} onChange={value => {
                                var inputValue = value.target.value.replace(/[a-zA-Z]/g, '');
                                setCouncilNumber(inputValue)
                            }} type="text" name="council_number" placeholder="Número do CRM" />
                        </div>

                        <div className="col-12 col-sm-4">
                            <label className="form-label-input">Estado*</label>
                            <select name="state" value={councilState} className="form-select" onChange={value => setCouncilState(value.target.value)} >
                                <option value="" disabled >Selecione um Estado</option>
                                <option value="AC">AC</option>
                                <option value="AL">AL</option>
                                <option value="AM">AM</option>
                                <option value="AP">AP</option>
                                <option value="BA">BA</option>
                                <option value="CE">CE</option>
                                <option value="DF">DF</option>
                                <option value="ES">ES</option>
                                <option value="GO">GO</option>
                                <option value="MA">MA</option>
                                <option value="MG">MG</option>
                                <option value="MS">MS</option>
                                <option value="MT">MT</option>
                                <option value="PA">PA</option>
                                <option value="PB">PB</option>
                                <option value="PE">PE</option>
                                <option value="PI">PI</option>
                                <option value="PR">PR</option>
                                <option value="RJ">RJ</option>
                                <option value="RN">RN</option>
                                <option value="RO">RO</option>
                                <option value="RS">RS</option>
                                <option value="SC">SC</option>
                                <option value="SE">SE</option>
                                <option value="SP">SP</option>
                                <option value="TO">TO</option>
                            </select>
                            {error.councilState && <span className="error" >Campo Inválido</span>}
                        </div>
                    </div>
                </div>
                <FooterAdd />
            </form>
        </>

    return (
        <Menu screen={screenTela} />
    )
}

export default ProfessionalsAdd;